import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
import * as reducers from 'src/redux/reducers';
import createSagaMiddleware from 'redux-saga';
import rootSaga from 'src/redux/sagas';
import getConfig from 'src/utils/getConfig';
import { prefixPath } from 'src/utils/capabilities';
import promiseMiddleware from './promiseMiddleware';

const browserHistory = createBrowserHistory({ basename: prefixPath + '/' });

const sagaMiddleware = createSagaMiddleware();

const rootReducer = combineReducers({
  ...reducers,
});

const middleware = compose(
  applyMiddleware(promiseMiddleware, sagaMiddleware),
  window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : f => f,
);

const store = createStore(rootReducer, getConfig(), middleware);

sagaMiddleware.run(rootSaga);

export default store;
export { browserHistory };
